import { render, staticRenderFns } from "./ChannelsLink.vue?vue&type=template&id=36b6188e&scoped=true&"
import script from "./ChannelsLink.vue?vue&type=script&lang=js&"
export * from "./ChannelsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6188e",
  null
  
)

export default component.exports